import { render, staticRenderFns } from "./raisedApprovalRequest.vue?vue&type=template&id=799cfa86&scoped=true"
import script from "./raisedApprovalRequest.vue?vue&type=script&lang=js"
export * from "./raisedApprovalRequest.vue?vue&type=script&lang=js"
import style0 from "./raisedApprovalRequest.vue?vue&type=style&index=0&id=799cfa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cfa86",
  null
  
)

export default component.exports